import * as types from '../mutation-types'
import * as constants from '../../mixins/constants'

// rental-form can use all state of order-form module
const state = {
  number_of_drivers: constants.RENTAL_DEFAULT_NUMBER_OF_DRIVER,
  hours_of_rental: 0,
  booking_description: ''
}

const getters = {
  orderFormBookingDescription: (state) => state.booking_description,
  orderFormNumberOfDriver: (state) => state.number_of_drivers,
  orderFormHoursOfRental: (state) => state.hours_of_rental
}

const actions = {
  addBookingDescription({ commit }, value) {
    commit(types.ADD_BOOKING_DESCRIPTION, value)
  }
}

const mutations = {
  [types.ADD_BOOKING_DESCRIPTION](state, data) {
    state.booking_description = data
  },
  [types.SET_ORDER_FORM_NUMBER_OF_DRIVERS](state, num) {
    state.number_of_drivers = num
  },
  [types.SET_ORDER_FORM_HOURS_OF_RENTAL](state, num) {
    state.hours_of_rental = num
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
